import { Injectable } from '@angular/core';
import { resolve } from 'dns';
import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SubService {
  public genericChannel = new BehaviorSubject({});
  set broadcast(obj){
      this.genericChannel.next(obj);
  }
  get listen(){
      return this.genericChannel;
  }
  sleep(ms){
      return new Promise((resolve)=>{
          setTimeout(()=>{ resolve(ms); }, ms);
      });
  }
}